import { Subject } from 'rxjs';

export default class LoaderUIService {
	autolinkingSubject = new Subject();

	toggleIsAutolinking = (isAutoLinking) => {
		this.autolinkingSubject.next(isAutoLinking);
	};
}
